var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 6.99992C6.0835 6.99992 5.29877 6.67353 4.646 6.02075C3.99322 5.36797 3.66683 4.58325 3.66683 3.66658C3.66683 2.74992 3.99322 1.9652 4.646 1.31242C5.29877 0.659641 6.0835 0.333252 7.00016 0.333252C7.91683 0.333252 8.70155 0.659641 9.35433 1.31242C10.0071 1.9652 10.3335 2.74992 10.3335 3.66658C10.3335 4.58325 10.0071 5.36797 9.35433 6.02075C8.70155 6.67353 7.91683 6.99992 7.00016 6.99992ZM0.333496 13.6666V11.3333C0.333496 10.861 0.455024 10.427 0.698079 10.0312C0.941135 9.63533 1.26405 9.33325 1.66683 9.12492C2.52794 8.69436 3.40294 8.37145 4.29183 8.15617C5.18072 7.94089 6.0835 7.83325 7.00016 7.83325C7.91683 7.83325 8.81961 7.94089 9.7085 8.15617C10.5974 8.37145 11.4724 8.69436 12.3335 9.12492C12.7363 9.33325 13.0592 9.63533 13.3022 10.0312C13.5453 10.427 13.6668 10.861 13.6668 11.3333V13.6666H0.333496Z",
    fill: "#2C8C53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.3f8f1c6db69a062dff3d8d694673beb4.svg";
export { ForwardRef as ReactComponent };